import React from "react";
import styled from "@emotion/styled";
import { designTokens } from "../../helpers/constants";

export enum EmptyStateType {
  NoResources,
  NoCurrentResources,
}

export interface EmptyStateProps {
  type: EmptyStateType | null;
}
const PRODUCT_LISTINGS_LINK = "https://www.teacherspayteachers.com/My-Products";
const MORE_INFO_LINK =
  "https://help.teacherspayteachers.com/hc/en-us/articles/4402683702548-Why-isn-t-my-new-product-listing-appearing-in-Easel-";

export const EmptyState: React.FC<EmptyStateProps> = (
  props: EmptyStateProps
) => {
  const { type } = props;

  return (
    <NoResources data-testid={`empty-state-${type}`}>
      <span id="heading">
        {type === EmptyStateType.NoCurrentResources
          ? "No listings match this search"
          : "You haven't created any listings."}
      </span>
      <span>
        {type === EmptyStateType.NoCurrentResources ? (
          <a target="_blank" rel="noreferrer" href={MORE_INFO_LINK}>
            Why can&#39;t I find my listing?
          </a>
        ) : (
          <>
            Go to the{" "}
            <a target="_blank" rel="noreferrer" href={PRODUCT_LISTINGS_LINK}>
              Product Listings Page
            </a>{" "}
            to create a new Listing.
          </>
        )}
      </span>
    </NoResources>
  );
};

const NoResources = styled.div({
  width: "100%",
  height: "80%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  "#heading": {
    fontWeight: 500,
    fontSize: "1rem",
  },

  span: {
    padding: "0.5rem 0",
    fontSize: "0.875rem",

    a: {
      fontWeight: 500,
      color: designTokens["ds-color-green-600"],
      textDecoration: "none",
    },
  },
});
